'use client';
import React, {useCallback} from 'react';
import {DepositSuccessModal, InterstitialsManager, Interstitials} from '@sdk-mobile';
import {useSearchParams, usePathname, useRouter} from 'next/navigation';
import Modal from '@/components/atoms/Modal';
import {removeSearchParams} from '@/utils/url-params';

const DepositSuccessParams = {
  depositSuccess: 'depositSuccess',
  amount: 'amount',
  bonusCash: 'bonusCash',
  promoCash: 'promoCash',
};

export default function DepositSuccess() {
  const searchParams = useSearchParams();
  const isDepositSuccess = searchParams?.get(DepositSuccessParams.depositSuccess);
  const depositAmount = searchParams?.get(DepositSuccessParams.amount);
  const bonusCash = searchParams?.get(DepositSuccessParams.bonusCash);
  const promoCash = searchParams?.get(DepositSuccessParams.promoCash);
  const pathname = usePathname();
  const router = useRouter();

  const handleDismiss = useCallback(() => {
    InterstitialsManager.sendTrigger(Interstitials.POST_DEPOSIT);
    if (!searchParams) return;

    // this is to preserve the query params except the depositSuccess ones
    router.replace(
      pathname +
        '?' +
        removeSearchParams(searchParams, Object.keys(DepositSuccessParams)).toString()
    );
  }, [pathname, router, searchParams]);

  if (depositAmount && isDepositSuccess) {
    return (
      <Modal>
        <DepositSuccessModal
          deposit={{
            depositAmount: parseFloat(depositAmount),
            bonusCash: parseFloat(bonusCash ?? '0'),
            promoCash: parseFloat(promoCash ?? '0'),
          }}
          onDismiss={handleDismiss}
        />
      </Modal>
    );
  }

  return null;
}
